@if (page$ | async; as page) {
    <div>
        <div fxLayout="row" fxLayoutAlign="space-between center">
            <div>
                <mat-form-field>
                    <mat-label>Suche</mat-label>
                    <input matInput
                           data-qa="netzbetreiber-search"
                           [formControl]="searchCtrl">
                    <mat-icon matSuffix svgIcon="innogy_picto_magnifier"></mat-icon>
                </mat-form-field>
            </div>
            <div class="reset-button-container">
                <button id="exportCsvButton" matButton="outlined" data-qa="export-csv-button"
                        (click)="exportNetzbetreiber()">
                    <mat-icon>file_download</mat-icon>
                    CSV exportieren
                </button>
            </div>
        </div>
        <div style="overflow: auto;" data-qa="kaskade-netzbetreiber-table">
            <table
                mat-table
                [dataSource]="netzbetreiberList"
                class="netzbetreiber-table"
                matSort
                [matSortDirection]="page.direction"
                [matSortActive]="page.sort"
                (matSortChange)="sortChange($event)">
                <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
                <tr style="cursor: pointer" mat-row *matRowDef="let netzbetreiber; columns: columnsToDisplay"
                    role="link"
                    tabindex="0"
                    (keydown.enter)="navigateToDetails(netzbetreiber)"
                    (click)="navigateToDetails(netzbetreiber)"
                    data-qa="tnb-netzbetreiber-row"></tr>
                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header data-qa="name">Name</th>
                    <td mat-cell *matCellDef="let netzbetreiber;" data-qa="row-name">{{ netzbetreiber.name }}</td>
                </ng-container>
                <ng-container matColumnDef="stadtwerkeId">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header data-qa="stadtwerkeId">Stadtwerke-ID</th>
                    <td mat-cell *matCellDef="let netzbetreiber;"
                        data-qa="row-stadtwerkeId">{{ netzbetreiber.stadtwerkeId }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="teilgebiet">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header data-qa="teilgebiet">Teilgebiet</th>
                    <td mat-cell *matCellDef="let netzbetreiber;"
                        data-qa="row-teilgebiet">{{ netzbetreiber.teilgebiet }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="schaltleitungen">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header data-qa="schaltleitungen">Schaltleitungen</th>
                    <td mat-cell *matCellDef="let netzbetreiber;" data-qa="row-schaltleitungen">
                        {{ flattenSchaltleitungen(netzbetreiber.schaltleitungen) }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="kundenbetreuerList">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header data-qa="nameKundenbetreuer">Name
                        Kundenbetreuer
                    </th>
                    <td mat-cell *matCellDef="let netzbetreiber;"
                        data-qa="row-nameKundenbetreuer">{{ flatten(netzbetreiber.kundenbetreuerList) }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="dienstleistungsartTitle">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header data-qa="dienstleistungsartTitle">
                        Dienstleistungsart
                    </th>
                    <td mat-cell *matCellDef="let netzbetreiber;" data-qa="row-dienstleistungsartTitle">
                        {{ netzbetreiber.dienstleistungsartTitle }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="netzbetreibernummer">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header data-qa="netzbetreibernummer">
                        Netzbetreibernummer
                    </th>
                    <td mat-cell *matCellDef="let netzbetreiber;"
                        data-qa="row-netzbetreibernummer">{{ netzbetreiber.netzbetreibernummer }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="lastChanged">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header data-qa="lastImportDate">Letzte
                        Aktualisierung
                    </th>
                    <td mat-cell *matCellDef="let netzbetreiber;" class="no-wrap" data-qa="row-lastImportDate">
                        {{ netzbetreiber.lastChanged | date: 'dd.MM.yyyy' }}
                        @if (netzbetreiber.dueClass === 'due') {
                            <mat-icon class="due" svgIcon="innogy_picto_speech-bubble_exclamationmark"></mat-icon>
                        }
                        @if (netzbetreiber.dueClass === 'overdue') {
                            <mat-icon class="overdue">alarm</mat-icon>
                        }
                        @if (netzbetreiber.dueClass === 'ok') {
                            <mat-icon class="ok" svgIcon="innogy_picto_check"></mat-icon>
                        }
                        @if (netzbetreiber.dueClass === 'notActive') {
                            <mat-icon class="notActive">indeterminate_check_box
                            </mat-icon>
                        }
                    </td>
                </ng-container>
                <ng-container matColumnDef="kaskadenKontakt.emailAlarmierungKaskade">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header data-qa="emailAlarmierungKaskade">Email
                        (Schaltberechtigt)
                    </th>
                    <td mat-cell *matCellDef="let netzbetreiber;"
                        data-qa="row-emailAlarmierungKaskade">{{ netzbetreiber.kaskadenKontakt?.emailAlarmierungKaskade }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="kaskadenKontakt.telefonAlarmierungKaskade">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Telefon (Schaltberechtigt)</th>
                    <td mat-cell
                        *matCellDef="let netzbetreiber;">{{ netzbetreiber.kaskadenKontakt?.telefonAlarmierungKaskade }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="kaskadenKontakt.emailInformationKaskade">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Email (Informativ)</th>
                    <td mat-cell
                        *matCellDef="let netzbetreiber;">{{ netzbetreiber.kaskadenKontakt?.emailInformationKaskade }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="kaskadenKontakt.telefonBereitschaft">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Telefon (Informativ)</th>
                    <td mat-cell
                        *matCellDef="let netzbetreiber;">{{ netzbetreiber.kaskadenKontakt?.telefonBereitschaft }}
                    </td>
                </ng-container>
            </table>
        </div>
        <mat-paginator #paginator
                       [showFirstLastButtons]="false"
                       [hidePageSize]="true"
                       [pageSize]="PAGE_SIZE"
                       [pageIndex]="page.page"
                       [length]="netzbetreiberList.filteredData.length"
                       (page)="pageChange($event)">
        </mat-paginator>
    </div>
}
